import React, {useEffect, useState} from 'react';
import {Header, Menu, Segment} from 'semantic-ui-react'
import './FloodMainComponent.css';
import FloodImpactTable from './FloodImpactTable';
import {FloodTableData, getSelectedTab, switchFloodTab} from "./slice";
import {MenuItemProps} from "semantic-ui-react/dist/commonjs/collections/Menu/MenuItem";
import {STORM_SURGE, RIVERINE} from "../../environment"

type props = {
    riverineData?: FloodTableData[]
    stormSurgeData?: FloodTableData[]
    showRiverineData: boolean
    showStormData: boolean
    activeTab: string | null | undefined
    onTabClick?: (event: React.MouseEvent<HTMLAnchorElement>, data: MenuItemProps) => void
}

const displayNoValueMessage = (type : String) => {
    return (
        <Segment attached className={'floodDetailsSegment'}>
            <Header className={'errorMessage'}>
                There are no {type} flood levels for this parcel
            </Header>
        </Segment>
    )
}

const FloodImpactTab = ({riverineData, stormSurgeData, showRiverineData, showStormData, activeTab, onTabClick}: props) => {
    return (
        <div>
            <Menu attached='top' tabular>
                <Menu.Item
                    name={RIVERINE}
                    active={(activeTab === RIVERINE)}
                    onClick={onTabClick}
                />
                <Menu.Item
                    name={STORM_SURGE}
                    active={(activeTab === STORM_SURGE)}
                    onClick={onTabClick}
                />
            </Menu>
            <div className={'floodTable'}>
                {(activeTab === RIVERINE) && showRiverineData && riverineData &&
                    <FloodImpactTable tableData={riverineData}/>}
                {(activeTab === RIVERINE) && (!showRiverineData || !riverineData) && displayNoValueMessage("riverine")}
                {(activeTab === STORM_SURGE) && (!showStormData || !stormSurgeData) && displayNoValueMessage("storm surge")}
                {(activeTab === STORM_SURGE) && showStormData && stormSurgeData &&
                    <FloodImpactTable tableData={stormSurgeData}/>}
            </div>
        </div>
    )

}

export default FloodImpactTab